
    import services from '@/services'
    import useStore from '@/hooks/useStore'
    import useIframeControl from '@/hooks/iframe'
    import useNavigation from '@/hooks/useNavigation'
    import { defineComponent, onMounted, reactive, watch } from 'vue'
    import { setBusiness, setData, setAttendance, setWebSocketToken, setApiId, setName, setEmail, setUser } from '@/store'
    import { getUser } from '@/helpers/tokenStorage'

    import Box from '@/views/WebChat/BoxWidget.vue'
    import Standby from '@/views/WebChat/StandbyWidget.vue'

    type State = {
        component: string,
        hasError: Error | null,
        data: object,
        loading: boolean
    }

    interface SetupReturn {
        state: State,
        handleOpenBox (): void,
        handleCloseBox (): void,
    }

    export default defineComponent({
        components: {
            Standby,
            Box
        },
        setup (): SetupReturn {
            const store = useStore()
            const {
                start,
                next,
                setErrorState
            } = useNavigation()

            const iframe = useIframeControl()

            const state = reactive<State>({
                component: 'Standby',
                loading: false,
                hasError: null,
                data: { webchat: '' }
            })

            const defaultWidget = {
                logo: '',
                title: 'Opps!',
                description: '...',
                timeAttendance: '...',
                busine: '',
                bgColor: 'bg-blue-700',
                color: '#00BCD4',
                token: ''
            }

            setData(defaultWidget)

            async function handleMountChat () {
                try {
                    const user = getUser()
                    const response = await services.webchat.mount({
                        page: store.currentPage,
                        apiKey: store.apiKey,
                        device: window.navigator.userAgent,
                        user,
                    })

                    if (response.errors) {
                        setErrorState()
                        return
                    }

                    // TODO: Update API, no necessary decrypt data
                    setData(response.data.webchat)
                    setBusiness(response.data.business_id)
                    setApiId(response.data.api_id)
                    setWebSocketToken(response.data.token)

                    if (response.data.client?.id) {
                        setName(response.data.client.name)
                        setEmail(response.data.client.email)
                        setUser(response.data.client.user)
                    }

                    if (!response.data.attendance) {
                        start()
                        return
                    }

                    setAttendance(response.data.attendance)

                    next()
                } catch (error) {
                    console.error('[CHAT] Error on mount chat', error)
                    handleError(error as Error)
                }
            }

            function handleError (error: Error) {
                state.hasError = error
                setErrorState()
            }

            watch(() => store.currentComponent, () => {
                iframe.updateCoreValuesOnStore()
            })

            onMounted(async () => {
                state.loading = true
                iframe.updateCoreValuesOnStore()
                await handleMountChat()
                state.loading = false
            })

            function handleOpenBox (): void {
                iframe.notifyOpen()
                state.component = 'Box'
            }

            function handleCloseBox (): void {
                iframe.notifyClose()
                state.component = 'Standby'
            }

            return {
                state,
                handleOpenBox,
                handleCloseBox
            }
        }
    })
